import { PatternFormat } from "react-number-format";
import { ariaLabelledbyProps } from "@design-system/formControl/ariaLabelledbyProps";
import type { ValueControlProps } from "@design-system/formControl/formControl.types";
import { createCustomInputsBySize } from "@design-system/Input/inputCustomInputs";
import { InputSize, toDsInputSize } from "@helpers/form";
import styles from "./PhoneInput.module.scss";

const inputsBySize = createCustomInputsBySize();

export interface PhoneInputProps extends ValueControlProps<
    string,
    HTMLInputElement
> {
    size?: InputSize;
    /** Id of a visible element elsewhere that names the input. */
    "aria-labelledby"?: string;
}

/**
 * US phone number input masked as `(###) ###-####`. `value` and
 * `onValueChange` carry the digits only, without the mask.
 */
export const PhoneInput = ({
    value,
    onValueChange,
    onBlur,
    name,
    ref,
    invalid,
    disabled,
    readOnly,
    required,
    size,
    "aria-labelledby": ariaLabelledby,
}: PhoneInputProps) => (
    <PatternFormat
        value={value}
        onValueChange={({ value: digits }) => onValueChange(digits)}
        onBlur={() => onBlur?.()}
        format="(###) ###-####"
        allowEmptyFormatting
        mask="_"
        customInput={inputsBySize[toDsInputSize(size)]}
        className={value ? undefined : styles.empty}
        name={name}
        getInputRef={ref}
        aria-invalid={invalid || undefined}
        aria-required={required || undefined}
        {...ariaLabelledbyProps(ariaLabelledby)}
        disabled={disabled}
        readOnly={readOnly}
        autoComplete="tel"
    />
);
